import { useState } from "react";
import CompetitionReplayModal from "./CompetitionReplayModal.jsx";
import { publicReplayProps } from "./replayShared.jsx";
import Footer from "./Footer.jsx";

// THE PUBLIC REPLAY VIEWER, as a page of its own.
//
// The Winners page opens the same playback in a modal; this is what a
// shared link opens, and what a middle-click from that list gives you.
// Both go through publicReplayProps so the two cannot drift apart.
//
// A competition that has ended has nothing left to hide: the image is
// revealed, the answer is public, the result is listed. Watching it
// back is how somebody checks the result was honest — "so it can be
// shown publicly to prove the competition from start to end"
// (18 Sep 2026).
export default function ReplayPage({ competitionId, demoRouteToken = null }) {
  const [closed, setClosed] = useState(false);

  if (closed) {
    return (
      <div style={{ color: "var(--text-primary)", minHeight: "100vh" }}>
        <div style={{ maxWidth: 820, margin: "0 auto", padding: "0 20px 40px" }}>
          <h2>Replay closed</h2>
          <p style={{ opacity: 0.85 }}>
            <a href="/winners">Back to the winners list</a>
          </p>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={{ color: "var(--text-primary)", minHeight: "100vh" }}>
      <CompetitionReplayModal
        {...publicReplayProps(competitionId, demoRouteToken)}
        onClose={() => setClosed(true)}
      />
      <Footer />
    </div>
  );
}
